// import React, { useState } from 'react';
// import Lottie from "react-lottie-player";
// import animationData from "./signInAnim.json";

// const SignIn = () => {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [error, setError] = useState(null);  // For storing error messages
//   const [loading, setLoading] = useState(false); // For loading state

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);  // Set loading to true when submitting
//     setError(null);    // Reset error message
  
//     try {
//       const response = await fetch("/api/signin", {  // Notice the relative URL here
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           email,
//           password
//         }),
//       });
  
//       if (!response.ok) {
//         throw new Error('Invalid email or password');
//       }
  
//       const data = await response.json();
//       const { access_token, role } = data;  // Destructure access_token and role
  
//       localStorage.setItem('token', access_token); // Store the token
//       localStorage.setItem('role', role); // Store the role
  
//       window.location.href = "/";  // Redirect to the home page after successful sign-in
  
//       console.log('Sign in successful!', access_token, role);
//     } catch (error) {
//       setError('Invalid email or password');
//       console.error('Error during sign in:', error);
//     } finally {
//       setLoading(false);  // Set loading to false when request is complete
//     }
//   };

//   return (
//     <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 px-4 md:px-0">
//       <h1
//         className="home-heading text-4xl md:text-5xl font-bold mb-4"
//         style={{
//           color: '#bb2423', // Red color
//           fontFamily: 'Dancing Script, cursive',
//         }}
//       >
//         Brian Karsh
//       </h1>
      
//       {/* Container - Maintains full width on desktop, adjusts for mobile */}
//       <div className="w-full md:flex md:max-w-4xl mx-auto bg-white shadow-lg rounded-lg overflow-hidden">
//         {/* Left: Lottie Animation - Hidden on very small screens, comes back at sm breakpoint */}
//         <div className="hidden sm:block sm:w-full md:w-1/2 md:flex-1 py-6 flex justify-center items-center">
//           <Lottie
//             loop
//             animationData={animationData}
//             play
//             style={{ width: "80%", height: "80%" }}
//           />
//         </div>

//         {/* Right: Sign-In Form - Takes full width on mobile */}
//         <div className="w-full md:w-1/2 md:flex-1 p-6 md:p-8">
//           <h2 className="text-2xl md:text-3xl font-semibold mb-4 md:mb-6 text-center text-[#bb2423]">Sign In</h2>
          
//           <form onSubmit={handleSubmit}>
//             {/* Email Field */}
//             <div className="mb-4">
//               <label htmlFor="email" className="block text-gray-700">Email</label>
//               <input
//                 type="email"
//                 id="email"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 className="w-full px-4 py-2 md:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#bb2423]"
//                 required
//               />
//             </div>

//             {/* Password Field */}
//             <div className="mb-4 md:mb-6">
//               <label htmlFor="password" className="block text-gray-700">Password</label>
//               <input
//                 type="password"
//                 id="password"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 className="w-full px-4 py-2 md:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#bb2423]"
//                 required
//               />
//             </div>

//             {/* Sign In Button */}
//             <button
//               type="submit"
//               className="w-full py-2 md:py-3 bg-[#bb2423] text-white rounded-full hover:bg-[#9b1f1f] transition-colors"
//               disabled={loading} // Disable the button while loading
//             >
//               {loading ? 'Signing In...' : 'Sign In'}
//             </button>
//           </form>

//           {/* Display error message if there's an error */}
//           {error && <p className="text-center text-red-500 mt-3 md:mt-4 text-sm md:text-base">{error}</p>}

//           {/* Sign Up Link */}
//           <p className="mt-3 md:mt-4 text-center text-sm md:text-base text-gray-600">
//             Don't have an account?{' '}
//             <a href="/sign-up" className="text-[#bb2423] hover:text-[#9b1f1f]">
//               Sign Up
//             </a>
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SignIn;









import React, { useState } from 'react';
import Lottie from "react-lottie-player";
import animationData from "./signInAnim.json";

const SignIn = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);  // For storing error messages
  const [loading, setLoading] = useState(false); // For loading state
  const backendUrl = 'https://python-backend-68898252993.us-central1.run.app';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);  // Set loading to true when submitting
    setError(null);    // Reset error message
  
    try {
      const response = await fetch(`${backendUrl}/api/signin`, {  // Notice the relative URL here
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email,
          password
        }),
      });
  
      if (!response.ok) {
        throw new Error('Invalid email or password');
      }
  
      const data = await response.json();
      const { access_token, role } = data;  // Destructure access_token and role
  
      localStorage.setItem('token', access_token); // Store the token
      localStorage.setItem('role', role); // Store the role
  
      window.location.href = "/";  // Redirect to the home page after successful sign-in
  
      console.log('Sign in successful!', access_token, role);
    } catch (error) {
      setError('Invalid email or password');
      console.error('Error during sign in:', error);
    } finally {
      setLoading(false);  // Set loading to false when request is complete
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 px-4 md:px-0">
      <h1
        className="home-heading text-4xl md:text-5xl font-bold mb-4"
        style={{
          color: '#bb2423', // Red color
          fontFamily: 'Dancing Script, cursive',
        }}
      >
        Brian Karsh
      </h1>
      
      {/* Container - Maintains full width on desktop, adjusts for mobile */}
      <div className="w-full md:flex md:max-w-4xl mx-auto bg-white shadow-lg rounded-lg overflow-hidden">
        {/* Left: Lottie Animation - Hidden on very small screens, comes back at sm breakpoint */}
        <div className="hidden sm:block sm:w-full md:w-1/2 md:flex-1 py-6 flex justify-center items-center">
          <Lottie
            loop
            animationData={animationData}
            play
            style={{ width: "80%", height: "80%" }}
          />
        </div>

        {/* Right: Sign-In Form - Takes full width on mobile */}
        <div className="w-full md:w-1/2 md:flex-1 p-6 md:p-8">
          <h2 className="text-2xl md:text-3xl font-semibold mb-4 md:mb-6 text-center text-[#bb2423]">Sign In</h2>
          
          <form onSubmit={handleSubmit}>
            {/* Email Field */}
            <div className="mb-4">
              <label htmlFor="email" className="block text-gray-700">Email</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-2 md:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#bb2423]"
                required
              />
            </div>

            {/* Password Field */}
            <div className="mb-4 md:mb-6">
              <label htmlFor="password" className="block text-gray-700">Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-2 md:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#bb2423]"
                required
              />
            </div>

            {/* Sign In Button */}
            <button
              type="submit"
              className="w-full py-2 md:py-3 bg-[#bb2423] text-white rounded-full hover:bg-[#9b1f1f] transition-colors"
              disabled={loading} // Disable the button while loading
            >
              {loading ? 'Signing In...' : 'Sign In'}
            </button>
          </form>

          {/* Display error message if there's an error */}
          {error && <p className="text-center text-red-500 mt-3 md:mt-4 text-sm md:text-base">{error}</p>}

          {/* Sign Up Link */}
          {/* <p className="mt-3 md:mt-4 text-center text-sm md:text-base text-gray-600">
            Don't have an account?{' '}
            <a href="/sign-up" className="text-[#bb2423] hover:text-[#9b1f1f]">
              Sign Up
            </a>
          </p> */}
        </div>
      </div>
    </div>
  );
};

export default SignIn;